import { Spin } from 'antd';
import React, { useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import TransactionDetailContainer from '@/containers/Transactions/Detail';
import { TransactionService } from '@/services';
import { useBeforeRender } from '@/hooks/useBeforeRender';
import { GlobalContext } from '@/contexts/GlobalContext';
import { ROUTES } from '@/constants';
import { TRANSACTION_STATUS } from '@/constants/transaction';

import './index.scss';

function TransactionDetail() {
  const { id } = useParams();
  const { t } = useTranslation();
  const [loading, setLoading] = useState(true);
  const [transaction, setTransaction] = useState({});
  const { pageTitle, setPageTitle, setTriggerFetchProfile } =
    useContext(GlobalContext);

  const fetchData = async () => {
    const { success, data } = await TransactionService.getTransactionDetail({
      id,
    });
    if (success) {
      setTransaction(data);
      setLoading(false);
    }
  };

  useBeforeRender(() => fetchData(), []);

  useEffect(() => {
    if (Object.keys(transaction).length > 0) {
      const statusText = TRANSACTION_STATUS.find(
        (item) => item.value === transaction.transactionStatus,
      )?.value;

      setPageTitle({
        ...pageTitle,
        title: `${t('transactions_page.detail.prefix_page_title', { id })}`,
        backUrl: ROUTES.TRANSACTIONS.INDEX,
        createdAt: transaction.createdAt,
        status: statusText,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [transaction, setPageTitle]);

  useEffect(() => {
    setTriggerFetchProfile(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="transactions-page">
      <Spin spinning={loading || !transaction}>
        <TransactionDetailContainer data={transaction} />
      </Spin>
    </div>
  );
}

export default TransactionDetail;
